import React from 'react';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { StatusToast } from '@fiverr-private/orca';
import { TOAST_DURATION } from './constants';

const raiseItemCreateSuccess = (collectionName) => {
    const { locale } = getContext();

    StatusToast.raise({
        message: <I18n k="collect_package.item_saved_in"
            params={{ collectionName }} locale={locale}/>,
        theme: StatusToast.THEMES.SUCCESS,
        duration: TOAST_DURATION
    });
};

export default raiseItemCreateSuccess;
